import { render, staticRenderFns } from "./TechnicianBulkNotifications.vue?vue&type=template&id=53b21885&"
import script from "./TechnicianBulkNotifications.vue?vue&type=script&lang=js&"
export * from "./TechnicianBulkNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports